import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=dff700da&scoped=true"
import script from "./Window.vue?vue&type=script&lang=js"
export * from "./Window.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Window.vue?vue&type=style&index=0&id=dff700da&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./Window.vue?vue&type=style&index=1&id=dff700da&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "dff700da",
  null
  ,true
)

export default component.exports